class BrandsDirectory extends HTMLElement {
  constructor() {
    super();
    this.onAlphabetClick = this.onAlphabetClick.bind(this);
  }

  connectedCallback() {
    this.alphabet = this.querySelector('.brands-directory__alphabet');
    if (!this.alphabet) return;

    this.alphabet.addEventListener('click', this.onAlphabetClick);
  }

  disconnectedCallback() {
    if (!this.alphabet) return;

    this.alphabet.removeEventListener('click', this.onAlphabetClick);
    this.alphabet = null;
  }

  onAlphabetClick(event) {
    const link = event.target.closest('.brands-directory__letter-link');
    if (!link) return;

    const target = this.getTarget(link);
    if (!target) return;

    // Suppress the browser's native anchor jump so a letter group that is
    // already on screen stays where it is.
    event.preventDefault();
    if (this.isInViewport(target)) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  getTarget(link) {
    const hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return null;

    return document.getElementById(hash.slice(1));
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }
}

if (!customElements.get('brands-directory')) {
  customElements.define('brands-directory', BrandsDirectory);
}
